import { render, staticRenderFns } from "./PersonalInfoCard.vue?vue&type=template&id=030d44b9&scoped=true&"
import script from "./PersonalInfoCard.vue?vue&type=script&lang=js&"
export * from "./PersonalInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./PersonalInfoCard.vue?vue&type=style&index=0&id=030d44b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030d44b9",
  null
  
)

export default component.exports